const monthNames = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
const dayNames = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];

$(document).ready(function() {
    var csvUrls = [
        'https://docs.google.com/spreadsheets/d/1jYL0x1NVQ3jQzx7deeOSep8WBRwLiLkcgqBSQ2VkoOs/pub?gid=0&single=true&output=csv',
        'https://docs.google.com/spreadsheets/d/1jYL0x1NVQ3jQzx7deeOSep8WBRwLiLkcgqBSQ2VkoOs/pub?gid=1607208632&single=true&output=csv',
    ];
    
    var allData = [];
    var loaded = 0;

    csvUrls.forEach(function(url) {
        Papa.parse(url, {
            download: true,
            header: true,
            delimiter: ",",
            complete: function(results) {
                allData = allData.concat(results.data);
                loaded++;
                if (loaded === csvUrls.length) {
                    initializeCalendar(allData);
                }
            }
        });
    });
});

function initializeCalendar(data) {
    var currentMonth = new Date().getMonth();
    var currentYear = new Date().getFullYear();
    
    renderCalendar(currentMonth, currentYear, data);
    //renderMonthEvents(currentMonth, currentYear, data);
    renderUpcomingEvents(data)
    $(document).on('click', '.prev-month', function() {
        currentMonth--;
        if (currentMonth < 0) {
            currentMonth = 11;
            currentYear--;
        }
        renderCalendar(currentMonth, currentYear, data);
        //renderMonthEvents(currentMonth, currentYear, data);
        renderUpcomingEvents(data)
    });
    
    $(document).on('click', '.next-month', function() {
        currentMonth++;
        if (currentMonth > 11) {
            currentMonth = 0;
            currentYear++;
        }
        renderCalendar(currentMonth, currentYear, data);
        //renderMonthEvents(currentMonth, currentYear, data);
        renderUpcomingEvents(data)
    });

    $('html').on('click', '#calendar .day.has-event', function() {
        var date = $(this).data('date');
        var events = data.filter(item => item["Datum"] === date);
        var popupContent = events.map(event => {
            return `
                <div class="event">
                <span class="close"></span>
                ${event["Název události"] ? `
                    <div class="event-name"><p>${event["Název události"]}</p></div>
                    <div class="event-date"><p>${event["Datum"] || ''}</p><span class="social"><span class="googleCalendar"></span></div>
                    <div class="event-time"><p>${event["Čas události"]}</p></div>
                    ${event["Adresa události"] ? `<div class="event-adress"><p>${event["Adresa události"]}</p></div>` : ''}
                    ${event["Text události"] ? `<div class="event-description"><p>${event["Text události"] || ''}</p></div>` : ''}
                    
                   
                ` : `
                    <div class="event-name"><p>Zannia má otevřeno</p></div>
                    <div class="event-date"><p>${event["Datum"]}</p><span class="social"><span class="googleCalendar"></span></div>
                    <div class="event-time"><p>${event["Čas události"]}</p></div>
                    <div class="event-adress"><p>Vančurova 45, 339 01 Klatovy</p></div>
                    <div class="rezervation"><p>Zarezervujte si můj čas s Vámi v Zannii. Poradím s výběrem a společně vybereme ty správné kousky do Vašeho šatníku.</p><p><span class="btn btn-primary" data-href="rezervationForm" data-time="${event["Čas události"]}" data-date="${event["Datum"]}">Rezervovat</span></p></div>
                `}
            </div>
            `;
        });
        $('#popup').html(popupContent).addClass('open');
    });

    // Hide popup when clicking outside of a day with an event
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.day.has-event').length) {
            $('#popup').removeClass('open');
        }
    });
}

function renderCalendar(month, year, data) {
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var firstDay = new Date(year, month, 1).getDay();
    var firstDayAdjusted = (firstDay === 0 ? 6 : firstDay - 1);
    var daysInPrevMonth = new Date(year, month, 0).getDate();
    var calendarHtml = `<div class="month">
                            <button class="prev-month">Previous</button>
                            ${monthNames[month]} ${year}
                            <button class="next-month">Next</button>
                        </div>
                        <div class="day-names">`;

    dayNames.forEach(day => {
        calendarHtml += `<div class="day-name">${day}</div>`;
    });

    calendarHtml += `</div><div class="days">`;

    for (var i = firstDayAdjusted; i > 0; i--) {
        var dateStr = `${daysInPrevMonth - i + 1}.${(month === 0 ? 12 : month)}.${(month === 0 ? year - 1 : year)}`;
        var hasEvent = data.some(item => item["Datum"] === dateStr);
        var hasUdalost = data.some(item => item["Datum"] === dateStr && item["Název události"]);
        var additionalClass = hasUdalost ? 'specialEvent' : 'zaniaOpen';
    
        calendarHtml += `<div class="day other-month ${hasEvent ? 'has-event' : ''} ${additionalClass}" data-date="${dateStr}">
                            <div class="inner">${daysInPrevMonth - i + 1}</div>
                        </div>`;
    }

    for (var day = 1; day <= daysInMonth; day++) {
        var dateStr = `${day}.${(month + 1)}.${year}`;
        var hasEvent = data.some(item => item["Datum"] === dateStr);
        var hasUdalost = data.some(item => item["Datum"] === dateStr && item["Název události"]);
        var additionalClass = hasUdalost ? 'specialEvent' : 'zaniaOpen';
    
        calendarHtml += `<div class="day ${hasEvent ? 'has-event' : ''} ${additionalClass}" data-date="${dateStr}">
                            <div class="inner">${day}</div>
                        </div>`;
    }

    var daysInNextMonth = 42 - (firstDayAdjusted + daysInMonth); // Ensuring 6 weeks display

    for (var j = 1; j <= daysInNextMonth; j++) {
        var dateStr = `${j}.${(month + 2 === 13 ? 1 : month + 2)}.${(month + 2 === 13 ? year + 1 : year)}`;
        var hasEvent = data.some(item => item["Datum"] === dateStr);
        calendarHtml += `<div class="day other-month ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                            <div class="inner">${j}</div>
                        </div>`;
    }

    calendarHtml += '</div><div id="popup"></div>';
    $('.calendarAndAction .left').html('<div id="calendar">'+calendarHtml+'</div>');

    // Check if last week contains only next month days
    const days = $('#calendar .days .day');
    const lastWeekDays = days.slice(-7);
    const lastWeekContainsOnlyNextMonthDays = lastWeekDays.toArray().every(day => $(day).hasClass('other-month'));

    if (lastWeekContainsOnlyNextMonthDays) {
        lastWeekDays.remove();
    }
}

function renderMonthEvents(month, year, data) {
    var monthEvents = data.filter(item => {

       //console.log(item)
        // Zkontrolujte, zda je "Datum" definováno, než se pokusíte jej rozdělit
        if (!item["Datum"]) {
            return false; // Přeskočte položky bez data
        }
        
        var dateParts = item["Datum"].split(".");
        var eventMonth = parseInt(dateParts[1], 10) - 1;
        var eventYear = parseInt(dateParts[2], 10);
        return eventMonth === month && eventYear === year;
    });
    var eventsHtml = '<h5>Nadcházející události</h5>'
    eventsHtml += monthEvents.map(event => {        
        return `
            <div class="event eventRight">
                <div class="event-date"><p>${event["Datum"]}</p></div>
                ${event["Název události"] ? `
                    <div class="event-name"><p>${event["Název události"]}</p></div>                   
                ` : `
                    <div class="event-name"><p>Zannia má otevřeno</p></div>
                `}
            </div>
        `;
    }).join("");

    $('.calendarAndAction .right').html(eventsHtml);
}

function renderUpcomingEvents(data) {
    var today = new Date();

    var upcomingEvents = data.filter(item => {
        if (!item["Datum"]) {
            return false; // Přeskočte položky bez data
        }

        var dateParts = item["Datum"].split(".");
        var eventDate = new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10));

        return eventDate >= today; // Vyber jen události, které jsou v budoucnosti
    });

    // Seřaď události podle data
    upcomingEvents.sort((a, b) => {
        var aDateParts = a["Datum"].split(".");
        var aDate = new Date(parseInt(aDateParts[2], 10), parseInt(aDateParts[1], 10) - 1, parseInt(aDateParts[0], 10));

        var bDateParts = b["Datum"].split(".");
        var bDate = new Date(parseInt(bDateParts[2], 10), parseInt(bDateParts[1], 10) - 1, parseInt(bDateParts[0], 10));

        return aDate - bDate; // Seřadí podle data vzestupně
    });

    // Vyber prvních 6 událostí
    var eventsToShow = upcomingEvents.slice(0, 6);

    var eventsHtml = '<h5>Nadcházející události</h5>';

    // Pokud nejsou žádné události, zobraz hlášku
    if (eventsToShow.length === 0) {
        eventsHtml += '<p>Žádné nadcházející události</p>';
    } else {
        eventsHtml += eventsToShow.map(event => {
            return `
                <div class="event eventRight">
                    <div class="event-date"><p>${event["Datum"]}</p></div>
                    ${event["Název události"] ? `
                        <div class="event-name"><p>${event["Název události"]}</p></div>
                    ` : `
                        <div class="event-name"><p>Zannia má otevřeno</p></div>
                    `}
                </div>
            `;
        }).join("");
    }

    $('.calendarAndAction .right').html(eventsHtml);
}

$(document).on('click', '.googleCalendar', function(event) {
    event.preventDefault();
    var eventTitle = $(this).closest('#popup').find('.event-name p').text().trim();
    var eventDescription = $(this).closest('#popup').find('.event-description p').text().trim();
    var eventLocation = $(this).closest('#popup').find('.event-adress p').text().trim();
    var eventDate = $(this).closest('#popup').find('.event-date p').text().trim(); // formát: DD.MM.YYYY
    var eventTime = $(this).closest('#popup').find('.event-time p').text().trim(); // formát: HH:MM - HH:MM
        
    // Převeďte datum a časy na formát YYYYMMDDTHHmmssZ
    var dateParts = eventDate.split(".");
    var startDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    var timeParts = eventTime.split("-");
   // console.log(timeParts)
    var startTime = timeParts[0].split(":");
    var endTime = timeParts[1].split(":");
  
    startDate.setHours(startTime[0], startTime[1]);
    var startDateString = startDate.toISOString().replace(/-|:|\.\d\d\d/g, "");
    
    var endDate = new Date(startDate);
    endDate.setHours(endTime[0], endTime[1]);
    var endDateString = endDate.toISOString().replace(/-|:|\.\d\d\d/g, "");
        
    // Vytvořte URL pro Google Kalendář
    var googleCalendarUrl = "https://www.google.com/calendar/render?action=TEMPLATE" +
    "&text=" + encodeURIComponent(eventTitle) +
    "&dates=" + startDateString + "/" + endDateString +
    "&details=" + encodeURIComponent(eventDescription) +
    "&location=" + encodeURIComponent(eventLocation) +
    "&sf=true&output=xml";
    
    // Otevřete URL v novém okně nebo záložce
    window.open(googleCalendarUrl, '_blank');
});

$('html').on('click', '.rezervation span[data-href="rezervationForm"]', function(e){
    var date = $(this).data('date')
    var time = $(this).data('time')
    e.preventDefault();
    $.colorbox({
        html:  $('footer#footer .rezervationForm').closest('span').html(),
        width: 600,
        maxWidth: "90%",
        height: 600,
        maxHeight: "90%",
        className: "iframeForm",
        onComplete: function() {
            $('.customRezervationForm #date').val(date)
            $('.customRezervationForm #time').val(time)
        },
    });
});

$(document).on('submit', '.iframeForm .customRezervationForm', function(e){
    $(this).addClass('loading-form')
    e.preventDefault(); 
    var formName = $(this).find('#name').val()
    var formEmail = $(this).find('#email').val()
    var formTel = $(this).find('#tel').val()
    var formTime = $(this).find('#time').val()
    var formDate = $(this).find('#date').val()
    var formMessage = $(this).find('#message').val()
    var formdata = new FormData();
    formdata.append("name", formName);
    formdata.append("email", formEmail);
    formdata.append("phone", formTel);
    formdata.append("time", formTime);
    formdata.append("date", formDate);
    formdata.append("message", formMessage);
    var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };
    fetch("https://tools.shopcode.cz/e-mail_sender/zannia/www/", requestOptions)
    .then(response => response.json())
    .then(function(result){
    showMessage('Formulář byl úspěšně odeslán, budeme vás kontaktovat.', 'success', '', false, true);
        if(result.status === 'ok'){
            $('#poptavkovyForm').removeClass('loading-form')
        }
    })
    .catch(function(){
        showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
        $('#poptavkovyForm').removeClass('loading-form')
    })
});